/**
 * Created by Languagenut on 24/07/2019.
 */


import React  from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import {Badge , Navbar  , Nav , Button} from 'react-bootstrap'
import 'react-dates/initialize';
import ReportsServices from '../../services/reports-service.js';
import ReportStore from '../../store/report-store.js';
import Constants from '../../constants.js';
import Translation from '../../store/internationalization-store.js';
import Downloader from '../../classes/download.js';
import moment from 'moment';
import { DateRangePicker} from 'react-dates';

export default class Highscore extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        this.state = {
            tab:'class_league',
            justMine:false,
            startDate:moment().subtract(30, 'days'),
            endDate:moment(),
        };
    }

    componentWillMount(){
        ReportStore.on(Constants.GET_ACCOUNT_STUDENTS_HIGHSCORE , ()=>{
            this.setState({
                accountStudents:ReportStore.accountStudentsHighscore
            })
        });

        ReportStore.on(Constants.GET_CLASSES_HIGHSCORE , ()=>{
            this.setState({
                classes:ReportStore.classesHighscore
            })
        });

        ReportStore.on(Constants.GET_CLASSES_STUDENTS_HIGHSCORE , ()=>{
            this.setState({
                classStudents:ReportStore.studentsHighscore
            })
        })
    }

    componentDidMount(){
        ReportsServices.getClassesHighscore(this.state.startDate.unix(), this.state.endDate.unix());
        ReportsServices.getClassesStudentsHighscore(this.props.classID , this.state.startDate.unix(), this.state.endDate.unix());
        ReportsServices.getAccountStudentsHighscore(this.props.classID , this.state.startDate.unix(), this.state.endDate.unix());
    }

    handleSelect(tab){
        this.setState({
            tab:tab,
            justMine:false
        })
    }

    download(){
        var data = this.formatData(this.getData())

        var csv = [];

        var strip = function(text)
        {
            return String(text).replace(/,/g,"")
        }

        for(var i = 0 ; i < data.length; i++)
        {
            csv.push(strip(data[i].rank) + ',' + strip(data[i].name) + ',' + strip(data[i].score) )
        }

        (new Downloader()).download_csv(csv.join("\n"));
    }

    getData(){
        switch(this.state.tab)
        {
            case "class_league":   return this.state.classStudents || [];
            case "school_league":  return this.state.accountStudents || [];
            case "classes_league": return this.state.classes || [];
        }
    }

    formatData(data){

        data = data || [];
        data.sort(function(a, b) {
            return parseFloat(b.score) - parseFloat(a.score);
        });

        var _data = [];
        var paddingLength = 0;

        for(var idx = 0 ; idx < data.length; idx++)
        {
            if(idx == 0)
            {
                 paddingLength = String(data[idx].score).length;
            }

            if(this.state.justMine && data[idx].is_class == "1")
            {
                _data.push({
                    rank:(idx + 1),
                    is_class:data[idx].is_class,
                    score:data[idx].score,
                    name:data[idx].name
                })
            }

            if(!this.state.justMine)
            {
                _data.push({
                    rank:(idx + 1),
                    is_class:data[idx].is_class,
                    score:data[idx].score,
                    name:data[idx].name
                })
            }

        }

        return _data

    }

    getDescription(){
        switch(this.state.tab)
        {
            case "class_league":   return Translation.get(12674, "Class Leaderboard is a league table of the students in this class based on their points")
            case "school_league":  return Translation.get(12675, "All Students Leaderboard is a league table of all students in your school based on their points")
            case "classes_league": return Translation.get(12676, "The Classes Leaderboard is a league table of every class in your school based on their points")
            default: return "";
        }
    }

    getBody(){

        if(this.state.tab == "school_league")
        {
            return <div><small>{this.getDescription()}</small><br/><a onClick={this.toggleJustMine.bind(this)} className="hyperlink float-right">{!this.state.justMine ? Translation.get(12677 , "Show this class' students") : Translation.get(12768 , "Show all students in school")}</a><br/><br/></div>
        }

        return <span><small>{this.getDescription()}</small><br/><br/></span>;

    }

    shouldBold(cell , row){

        if(Number(row.rank) <= 3 ) return <b>{cell}</b>;

        return <span>{cell}</span>;
    }

    link(cell , row){

        if(Number(row.rank) <= 3 ) return <b>{cell}</b>;

        return <span >{cell}</span>;
    }

    badge(cell , row){
        if(Number(row.rank) <= 3 )
        {
            return <h5><Badge variant="primary" >{cell}</Badge></h5>;
        }

        return <h5><Badge variant="primary" >{cell}</Badge></h5>;
    }

    toggleJustMine(){
        this.setState({
            justMine:!this.state.justMine
        })
    }

    onSearch(){
        ReportsServices.getClassesHighscore(this.state.startDate.unix(), this.state.endDate.unix());
        ReportsServices.getClassesStudentsHighscore(this.props.classID , this.state.startDate.unix(), this.state.endDate.unix());
        ReportsServices.getAccountStudentsHighscore(this.props.classID , this.state.startDate.unix(), this.state.endDate.unix());
    }

    render(){

        const columns = [
            {
                dataField: 'is_class',
                hidden: true,
            },{
            dataField: 'rank',
            text: Translation.get(14 , 'Name'),
            sort: true,
            align:"left",
            classes:"mono",
            headerClasses:"hide",
            formatter:this.badge
        } , {
            dataField: 'name',
            text: Translation.get(14 , 'Name'),
            sort: true,
            align:"left",
            headerClasses:"hide",
            formatter:this.link
        } , {
            dataField: 'score',
            text: Translation.get(14 , 'Name'),
            align:"right",
            headerClasses:"hide",
            classes:"mono",
            formatter:this.shouldBold
        }];

        //#AF9500
        //#B4B4B4
        //#AD8A56

        const rowStyle2 = (row, rowIndex) => {
            const style = {
                border:'1.5px solid #1f1535',
                borderColor:'#1f1535',
                borderWidth:'1.5px'
            };

            if (rowIndex == 0 ) {
                style.backgroundColor = '#fcdfad';
            }

            if (rowIndex == 1 ) {
                style.backgroundColor = '#e5e3e5';
            }

            if (rowIndex == 2 ) {
                style.backgroundColor = '#f4b796';
            }

          /*  if (rowIndex > 2) {
                style.fontWeight = 'bold';
                style.color = 'white';
            }*/

            return style;
        };

        const rowClasses = (row, rowIndex) => {
            let classes = '';


            if(rowIndex == 0)
            {
                 classes = 'animated pulse delay-1s';
            }

            if(rowIndex == 1)
            {
                classes = 'animated pulse delay-2s';
            }

            if(rowIndex == 2)
            {
                classes = 'animated pulse delay-3s';
            }

            if (row.is_class) {
                classes = 'highlight-table-row';
            }

            return classes;
        };

        let search =   <div class="d-flex flex-row-reverse">
            <div style={{paddingTop:".5rem"}}> <Button onClick={this.onSearch.bind(this)}>{Translation.get(595 , "Search")}</Button></div>
            <div class="p-2">

                <DateRangePicker
                    displayFormat='DD/MM/YYYY'
                    isOutsideRange={(day) => day.isAfter(moment()) || day.isBefore(moment('05/11/2019',"DD/MM/YYYY"))}
                    disabled={false}
                    minDate={moment('05/11/2019',"DD/MM/YYYY")}
                    maxDate={moment()}
                    enableOutsideDays={false}
                    customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    />
            </div>
        </div>

        return <div>
            <Navbar style={{padding:0}}>
                <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                    <Nav.Item>
                        <Nav.Link style={{paddingLeft:"0"}} eventKey="class_league">{Translation.get(12678 , 'Class League')}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="school_league">{Translation.get(12679 , 'School League')}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link style={{paddingLeft:"0"}} eventKey="classes_league">{Translation.get(12680 , 'Classes League')}</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                    {search}
                    &nbsp;
                 <Button onClick={this.download.bind(this)}>{Translation.get(826 , 'Download')}</Button>
                </Navbar.Collapse>
            </Navbar>
            <hr style={{marginTop:".5rem"}}/>
           {this.getBody()}

            <BootstrapTable  rowStyle={ rowStyle2 } rowClasses={ rowClasses }   bordered={ false } keyField='id' data={ this.formatData(this.getData()) || [] } columns={ columns } />
        </div>
    }

}